export const RATING_INPUT_VALUES = [1, 2, 3, 4, 5];
export const MIN_RATING_INPUT_VALUE = RATING_INPUT_VALUES[0];
export const MAX_RATING_INPUT_VALUE = RATING_INPUT_VALUES[RATING_INPUT_VALUES.length - 1];
//# sourceMappingURL=constants.js.map